import type { AppointmentStatus } from '../api/types';

// Kalender: Farbe je Makler (Farbreihe --color-series-1 … 8 in styles/global.css) und Ziehen zum Verschieben.

export const seriesCount = 8;

// dragType: Datentyp beim Ziehen eines Termins (enthält die Termin-ID).
export const dragType = 'application/x-erfolgsmakler-appointment';

// seriesOf: Farbnummer je Makler in der Reihenfolge der Mitgliederliste (1 … 8, danach wiederholt).
export function seriesOf(userIds: string[]): Map<string, number> {
  return new Map(userIds.map((id, i) => [id, (i % seriesCount) + 1]));
}

// movable: nur geplante bzw. bestätigte Termine lassen sich verschieben.
export function movable(status: AppointmentStatus): boolean {
  return status === 'PLANNED' || status === 'NEEDS_CONFIRMATION' || status === 'CONFIRMED' || status === 'RESCHEDULED';
}
